import { render, staticRenderFns } from "./CreateEditCampaign.vue?vue&type=template&id=c10376ba"
import script from "./CreateEditCampaign.vue?vue&type=script&lang=js"
export * from "./CreateEditCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports